/**
 * The one small marker a section wears while it is still being built out.
 * The section itself stays open and clickable; the pill only says what to
 * expect of it today.
 */
export default function ComingSoonBadge({ es = false, className = "" }) {
  return (
    <span
      className={`inline-flex shrink-0 items-center gap-1.5 rounded-full border border-[#cfcfca] bg-[#EDEBE6] px-2.5 py-1 text-[9px] font-black uppercase tracking-[0.14em] text-[#6d6d6a] dark:border-white/[0.14] dark:bg-white/[0.08] dark:text-[#aca89f] ${className}`}>
      <span aria-hidden="true" className="h-1.5 w-1.5 rounded-full bg-[#9a9a94]" />
      {es ? "Próximamente" : "Coming soon"}
    </span>
  );
}